import { MovieOpenCogOutlineIcon } from './MovieOpenCogOutlineIcon';

/**
 * author: Colton Wiscombe
 * id F4936EA7-C151-4D41-84CC-4E02BCA4E01B
 * name movie-open-cog-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-cog-outline.svg
 * tags
 * - Video / Movie 
 * - Settings 
 */
export const FilmOpenCogOutlineIcon = MovieOpenCogOutlineIcon;
export default FilmOpenCogOutlineIcon